import { render } from "./DownloadPdfButton.vue?vue&type=template&id=be0025fe&scoped=true"
import script from "./DownloadPdfButton.vue?vue&type=script&lang=js"
export * from "./DownloadPdfButton.vue?vue&type=script&lang=js"

import "./DownloadPdfButton.vue?vue&type=style&index=0&id=be0025fe&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0025fe"]])

export default __exports__